import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=82d87e1a&lang=pug&"
import script from "./Language.vue?vue&type=script&lang=ts&"
export * from "./Language.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports